import { Modal } from "antd";
import React from "react";
import Loader from "../../SharedComponents/Loader/Loader";
import { useSelector } from "react-redux";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";

function Publishconfig({
  closable,
  open,
  onCancel,
  handleSuccess,
}: {
  closable: boolean;
  open: boolean;
  onCancel: () => void;
  handleSuccess: () => void;
}) {
  const { loading } = useSelector((state: any) => state.Dashboard);

  return (
    <>
      <Loader isLoader={loading} />

      <Modal open={open} closable={closable} footer={null} width={400}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Publish Config</h4>

          <p style={{ fontSize: "15px" }}>
            Are you want to publish the config?
          </p>

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Publish"
              onClick={handleSuccess}
              type="submit"
              style={{ padding: "7px 24px" }}
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              // style={{ backgroundColor: "#eb3131", padding: "7px 24px" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Publishconfig;
